import isDebugModeAllowed from 'views/components/utils/Debug/isDebugModeAllowed'

export default (state = false) => (isDebugModeAllowed() ? state : false)
